import { useQuery } from "@tanstack/react-query";
import { frequencyAPI } from "@/lib/frequency-api";
import { queryKeys } from "@/lib/query-keys";

export const useMonitoringFrequencies = () => {
  return useQuery({
    queryKey: queryKeys.consultation.catalogs.monitoringFrequencies(),
    queryFn: () => frequencyAPI.list(),
    staleTime: Infinity, // Frequencies are unlikely to change often
  });
};
